/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

const init = () => {
    const trackWithButtonPayload = (linkNode, positionNode) => {
        if (window.adobeDataLayer) {
            var trackingEventPayload = JSON.parse(linkNode.dataset.trackingEventPayload);
            if (trackingEventPayload) {
                var position = null;
                // check if current node has position attribute
                if (linkNode.dataset.trackingPosition) {
                    position = Number(linkNode.dataset.trackingPosition)
                } else if (positionNode && positionNode.dataset.trackingPosition) {
                    position = Number(positionNode.dataset.trackingPosition);
                }
                if (position) {
                    trackingEventPayload.position = position;
                }
            }
            var clickEvent = {
                event: linkNode.dataset.trackingClickEvent,
                payload: trackingEventPayload
            }
            window.adobeDataLayer.push(clickEvent);
        }
    }

    document.addEventListener("click", function (event) {
        var linkNode = event.target.closest('[data-tracking-click-event]');

        // Don't track if add to bag is not ready (we don't disable the button, so we must use a data attribute)
        if ($(linkNode).data('not-ready') === true) {
            return;
        }
        // Product Sets
        if (linkNode && linkNode.dataset.trackingClickEvent && $(linkNode).hasClass('add-to-cart-global')) {
            $('.product-detail .add-to-cart').each(function () {
                trackWithButtonPayload($(this).get(0), event.target.closest('[data-tracking-position]'));
            })
            return;
        }

        // Regular Product
        if (linkNode && linkNode.dataset.trackingClickEvent && linkNode.dataset.trackingEventPayload) {
            trackWithButtonPayload(linkNode, event.target.closest('[data-tracking-position]'));
        }
    });

    $('body').on('product:afterAddToCart', function (e, data) {
        if (window.adobeDataLayer) {
            window.adobeDataLayer.push(data.cartEvent);
        }
    });

    $('body').on('checkout:updateUrl', function (e, data) {
        if (window?.adobeDataLayer) {
            window.adobeDataLayer.push({
                event: 'PAGEVIEW',
                custom_pagename: `checkout - ${data.stageName}`
            });
        }
    });

    $('body').on('newsletter:subscribe', function (e, data) {
        if (data.success && window.adobeDataLayer) {
            window.adobeDataLayer.push({
                event: 'NEWSLETTER_SUBSCRIBE',
                source: data.source || 'footer'
            });
        }
    });

    // OneTrust calls the OptanonWrapper on load and when preferences change
    // Doc: https://my.onetrust.com/s/article/UUID-29158b4e-22f6-0067-aa36-94f3b8cf3561?language=en_US
    // When called, this script attempts to extract the group optin option. This value is then used to update the SFRA dw_dnt cookie value.
    let cookieCheckRetries = 0;
    const handleOptanonConsent = () => {
        const optanonConsent = getCookie('OptanonConsent');
        const currentDNTValue = Number(getCookie('dw_dnt') || 1);

        // Get Cookie Props
        const ocProps = {}
        optanonConsent.split('&').forEach(o => {
            const a = o.split('=');
            if (a?.length) {
                ocProps[a[0]] = a[1];
            }
        });

        // Check to see if we have group data
        if (!ocProps?.groups && cookieCheckRetries < 3) {
            cookieCheckRetries += 1;
            setTimeout(handleOptanonConsent, 500);
            return;
        }

        /*  
            One Trust "Group" Keys
            1:# = Required
            3:# = Functional
            4:# = Marketing
            6:# = Analytics

            Value: 
            1 = opt-in
            0 = opt-out

        */

        const groups = {
            required: 0,
            functional: 0,
            marketing: 0,
            analytics: 0
        }

        ocProps?.groups?.split(',').forEach(o => {
            const a = o.split(':');
            if (a?.length) {
                const type = a[0];
                const val = Number(a?.[1] || 0);
                switch (type) {
                    case '1':
                        groups.required = val;
                        break;
                    case '3':
                        groups.functional = val;
                        break;
                    case '4':
                        groups.marketing = val;
                        break;
                    case '6':
                        groups.analytics = val;
                        break;
                    default:
                        break;
                }
            }
        });

        // Update session dnt with the OneTrust setting
        var newDNTValue = groups.functional === 1 ? 0 : 1;
        if (newDNTValue !== currentDNTValue) {
            const $consentData = $('#onetrust-consent');

            if (!$consentData?.length) {
                return;
            }
            
            const url = newDNTValue === 1 ? $consentData.attr('data-reject') : $consentData.attr('data-accept');
            const token = $consentData.attr('data-token');
            const tokenName = $consentData.attr('data-tokenname');
            var data = {};
            data[tokenName] = token;

            $.ajax({
                url: url,
                type: 'post',
                data: data,
                dataType: 'json',
                error: function () {
                    window.reportError('Unable to track dnt consent preferences.')
                }
            });
        }
    }
    
    window.OptanonWrapper = handleOptanonConsent;
}


module.exports = {
    init
}